<template>
    <div class="md editor">
        <div class="caption">
            <div class="name">{{ caption }}
                <div class="sub">{{ sub }}</div>
                <slot></slot>
            </div>
            <div class="price">{{ showPrice }}</div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            caption: {
                type: String,
                required: false,
                default: ''
            },
            sub: {
                type: String,
                required: false,
                default: ''
            },
            price: {
                type: [String, Number],
                required: false,
                default: ''
            },
        },
        computed: {
            showPrice: function(){
                let _price = this.price,
                    _isNumber = true;
                    
                if( typeof _price === 'string' ) {
                    let _string = _price.replaceAll(',', '');

                    if( _string != parseFloat(_string, 10) ) {
                        _isNumber = false;
                    }

                }else if( typeof _price !== 'number' ) {
                    _isNumber = false;
                }

                if( _isNumber ) {
                    return 'NTD$ '+ _price;
                }else {
                    return _price;
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .md.editor {
        padding: $interval-l;
        border-radius: $border-radius;
        background-color: #ECECEC;

        .caption {
            font-size: $font-size-xxl;
            font-weight: bold;
        }
        
        .price {
            $type: map-get($colors, 'danger');
            $text: map-get($type, 'text');

            font-size: $font-size-xxxl;
            text-align: right;
            color: $text;
            font-weight: bold;
        }

        .sub{
            display: inline;
            font-size:$font-size-xs;
        }
    }
</style>
